export const generatePagesArray = (totalPages, currentPage, maxPagesDisplayed) => {
  const halfMaxPages = Math.floor(maxPagesDisplayed / 2)
  const startPage = Math.max(1, currentPage - halfMaxPages)
  const endPage = Math.min(totalPages, startPage + maxPagesDisplayed - 1)

  return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index)
}
